import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import "../css/DetailBlog.css";
import NavBarHome from "../components/NavBarHome";
import NavBar from "../components/NavBar";
import { BsArrowLeft } from "react-icons/bs";
import ShareModal from "../components/ShareModal";

const DetailBlog = () => {
  const { articleHandle } = useParams();
  const [article, setArticle] = useState(null);
  const [relatedArticles, setRelatedArticles] = useState([]);

  const domain = "c4x3xq-e0.myshopify.com";

  const email = localStorage.getItem("email");


  // useEffect(() => {
  //   const fetchArticle = async () => {
  //     const query = `{
  //       blogs(first: 10) {
  //         edges {
  //           node {
  //             handle
  //             articleByHandle(handle: "${articleHandle}") {
  //               title
  //               contentHtml
  //               publishedAt
  //               authorV2 {
  //                 name
  //               }
  //               image {
  //                 url
  //                 altText
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }`;

  //     const res = await fetch(`https://${domain}/api/2023-04/graphql.json`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "X-Shopify-Storefront-Access-Token":
  //           process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN,
  //       },
  //       body: JSON.stringify({ query }),
  //     });

  //     const data = await res.json();

  //     // Cari blog mana yang mengandung artikel
  //     const blogWithArticle = data.data.blogs.edges.find(
  //       (b) => b.node.articleByHandle
  //     );

  //     if (blogWithArticle) {
  //       setArticle(blogWithArticle.node.articleByHandle);
  //     }
  //   };

  //   fetchArticle();
  // }, [articleHandle]);

  useEffect(() => {
    const fetchArticles = async () => {
      const blogQuery = `{
        blogs(first: 10) {
          edges {
            node {
              handle
              articles(first: 50) {
                edges {
                  node {
                    id
                    title
                    handle
                    publishedAt
                    excerpt
                    contentHtml
                    image {
                      url
                      altText
                    }
                    authorV2 {
                      name
                    }
                  }
                }
              }
              articleByHandle(handle: "${articleHandle}") {
                title
                contentHtml
                publishedAt
                authorV2 {
                  name
                }
                image {
                  url
                  altText
                }
              }
            }
          }
        }
      }`;

      const res = await fetch(`https://${domain}/api/2023-04/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query: blogQuery }),
      });

      const data = await res.json();

      const blogWithArticle = data.data.blogs.edges.find(
        (b) => b.node.articleByHandle
      );

      if (blogWithArticle) {
        const fetchedArticle = blogWithArticle.node.articleByHandle;
        setArticle(fetchedArticle);

        const allArticles = data.data.blogs.edges.flatMap((b) =>
          b.node.articles.edges.map((edge) => ({
            ...edge.node,
          }))
        );

        // Filter out current article
        const otherArticles = allArticles
        .filter((a) => a.handle !== articleHandle)
        .sort(() => Math.random() - 0.5)
        .slice(0, 3);
        // Sort by date
        otherArticles.sort((a, b) => {
          return new Date(b.publishedAt) - new Date(a.publishedAt);
        });

        setRelatedArticles(otherArticles.slice(0, 3)); // Batasin misalnya 4 saja
      }
    };

    fetchArticles();
  }, [articleHandle]);

  if (!article) return <div className="loading-detailBlog">Loading article...</div>;

  return (
    <>
      {email == "null" ? (
        <NavBar page={"blog"} />
      ) : (
        <NavBarHome page={"blog"} />
      )}
      <div className="detailblog-container">
        <div className="blog-detail">
          <h1>{article.title}</h1>
          <p className="blog-date">
            {new Date(article.publishedAt).toLocaleDateString("en-US", {
              day: "numeric",
              month: "long",
              year: "numeric",
              timeZone: "UTC"
            })}{" "}
            <span className="dot-separator">•</span> {article.authorV2.name}
          </p>
          <ShareModal/>
          <div
            dangerouslySetInnerHTML={{ __html: article.contentHtml }}
            className="blog-body"
          />
        </div>
        <div className="blog-footer">
          <div className="blog-footer-link">
            <Link to={"/blog"}>
              <BsArrowLeft /> <span>Back to blog</span>
            </Link>
          </div>
          <div className="blog-footer-mirror-blogs">
            <h2>Discover more!</h2>
            <div className="blog-footer-mirror-content">
              {relatedArticles.map((article) => (
                <Link
                  to={`/blog/${article.handle}`}
                  className="blog-card"
                  key={article.id}
                >
                  {article.image?.url && (
                    <img
                      src={article.image.url}
                      alt={article.image.altText || article.title}
                      className="blog-thumbnail"
                    />
                  )}
                  <div className="blog-content">
                    <h3 className="blog-heading">{article.title}</h3>
                    <p className="blog-meta">
                      {new Date(article.publishedAt).toLocaleDateString(
                        "en-US",
                        {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        }
                      )}{" "}
                      <span className="dot-separator-blog">•</span>{" "}
                      {article.authorV2.name}
                    </p>
                    <p className="blog-excerpt">
                      {article.excerpt ||
                        article.contentHtml
                          .replace(/<[^>]+>/g, "")
                          .slice(0, 150) + "..."}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className="blog-footer-button">
            <Link to={"/blog"}>
              View all
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailBlog;
